import React from 'react';
import { Box, TextField, InputAdornment, Typography, Avatar, Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { radius } from '../../themes/smartinventoryTheme';

// Searchable single-select card list for choosing a company user — mirrors
// ProductPicker's layout so pickers across the admin dashboard read as one
// system. `users`: [{ id, username, email, role }].
const UserPicker = ({ users, value, onChange, searchValue, onSearchChange, searchPlaceholder, emptyLabel }) => (
  <Box>
    <TextField
      fullWidth
      value={searchValue}
      onChange={onSearchChange}
      placeholder={searchPlaceholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      sx={{ mb: 1.5 }}
    />
    <Box role="listbox" sx={{ maxHeight: 360, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 1 }}>
      {users.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 3 }}>
          {emptyLabel}
        </Typography>
      )}
      {users.map((user) => {
        const selected = user.id === value;
        return (
          <Box
            key={user.id}
            role="option"
            aria-selected={selected}
            onClick={() => onChange(user.id)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 1.25,
              border: '1px solid',
              borderColor: selected ? 'primary.main' : 'divider',
              borderRadius: `${radius.md}px`,
              bgcolor: selected ? 'primary.light' : 'transparent',
              cursor: 'pointer',
            }}
          >
            <Avatar
              sx={{
                width: 46,
                height: 46,
                borderRadius: `${radius.sm}px`,
                flexShrink: 0,
                ...(selected && { bgcolor: 'primary.main', color: 'primary.contrastText' }),
              }}
            >
              {user.username ? user.username.trim().charAt(0).toUpperCase() : '?'}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="subtitle1" noWrap>{user.username}</Typography>
              {user.email && (
                <Typography variant="body2" color="text.secondary" noWrap>{user.email}</Typography>
              )}
            </Box>
            {user.role && (
              <Chip label={user.role} size="small" variant="outlined" sx={{ textTransform: 'capitalize' }} />
            )}
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default UserPicker;
